module.exports = __webpack_public_path__ + "img/excel.fde11ea8.svg";